export class Cell {
  value: string;
  id: string;
  name: string;
  sum: boolean;
}
